import React from "react";
import styled from "styled-components";
import { Color, Radius, content } from "@glossy";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

export const AI_GRADIENT = { start: "#B627A1", stop: "#1D9F9F" };

const StyledButton = styled(Button)`
  position: relative;
  color: ${content};

  svg {
    color: ${AI_GRADIENT.start} !important;
  }

  &:before {
    pointer-events: none;
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    border: 1px solid transparent;
    border-radius: ${Radius.Medium};
    background: linear-gradient(to bottom, ${Color.White}, ${Color.White})
        content-box,
      linear-gradient(to right, ${AI_GRADIENT.start}, ${AI_GRADIENT.stop})
        border-box;
    mix-blend-mode: multiply;
  }
`;

export const CallAicha = ({ onOpen, isExplanationOpen, locale }) => (
  <div style={{ visibility: isExplanationOpen ? "hidden" : "visible" }}>
    <StyledButton
      icon="magic"
      text={tr(locale, "DISCOVERY::AICHA::OPEN_BUTTON")}
      size="m"
      onClick={() => {
        onOpen(true);
      }}
    />
  </div>
);
